import { IdValue } from '../types/props';

export enum CountryEnum {
  KZ = 'Қазақстан',
  RU = 'Россия',
  US = 'United States',
  UZ = 'Oʻzbekiston',
}

export const countryMap: Record<string, string> = {
  KZ: 'Қазақстан',
  RU: 'Россия',
  US: 'United States',
  UZ: 'Oʻzbekiston',
};

export const countryArray: IdValue[] = Object.entries(CountryEnum).map(([key, value]) => ({
  id: key,
  value: value,
}));

